import { useGetAllRegions } from '@/hooks/data/masterDataHook';

import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  countryId?: string | null | undefined;
}
export default function RegionInput({ countryId, ...props }: Props) {
  const { data, isLoading } = useGetAllRegions();

  const regions = React.useMemo(() => {
    if (countryId) {
      return data?.data?.filter(x => x.countryId === countryId) || [];
    }
    return data?.data || [];
  }, [data, countryId]);
  return (
    <Select
      loading={isLoading}
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {regions.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.regionName}
          </Select.Option>
        );
      })}
    </Select>
  );
}
